<h2 mat-dialog-title>Cerca per posizione sulla mappa</h2>

<!-- Solo il campo geocoding dentro mat-dialog-content -->
<div mat-dialog-content class="geocode-content">
  <div class="geocode-wrapper">
    <mat-form-field appearance="outline" class="geocode-field">
      <mat-label>Cerca un indirizzo</mat-label>
      <input matInput [formControl]="addressControl" autocomplete="off" />
      <mat-spinner matSuffix *ngIf="geocodeLoading" diameter="18" style="margin-right: 8px;"></mat-spinner>
      <mat-icon matSuffix *ngIf="!geocodeLoading">search</mat-icon>
    </mat-form-field>

    <div class="geocode-results" *ngIf="geocodeResults.length > 0">
      <mat-list dense>
        <mat-list-item
          *ngFor="let result of geocodeResults"
          (click)="selectGeocodeResult(result)"
          class="geocode-result-item">
          <mat-icon mat-list-icon>place</mat-icon>
          <span mat-line>{{ result.display_name }}</span>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</div>

<!-- Mappa, hint e buffer FUORI da mat-dialog-content:
     evita gli offset di Leaflet causati dallo scrolling/overflow dell'ancestor -->
<div class="map-outer">

  <div #mapContainer class="map-container"></div>

  <!-- Suggerimento selezione punto -->
  <p class="map-hint" *ngIf="selectedLat === null && !hasSearched">
    <mat-icon style="font-size:14px; vertical-align:middle;">info</mat-icon>
    Clicca sulla mappa per selezionare un punto
  </p>
  <p class="map-hint selected" *ngIf="selectedLat !== null && searchResults.length === 0 && !hasSearched">
    <mat-icon style="font-size:14px; vertical-align:middle;">check_circle</mat-icon>
    Posizione: {{ selectedLat | number:'1.5-5' }}, {{ selectedLon | number:'1.5-5' }}
  </p>

  <!-- Risultati ricerca: info count o no-results -->
  <div class="search-results-bar" *ngIf="hasSearched && !searchLoading">
    <ng-container *ngIf="searchResults.length > 0">
      <mat-icon class="bar-icon">place</mat-icon>
      <span>{{ searchResults.length }} edifici trovati — clicca un marker per selezionare</span>
      <button mat-button color="warn" class="reset-btn" (click)="resetSearch()">
        <mat-icon>restart_alt</mat-icon> Nuova ricerca
      </button>
    </ng-container>
    <ng-container *ngIf="searchResults.length === 0">
      <mat-icon class="bar-icon warn-icon">search_off</mat-icon>
      <span>Nessun edificio trovato nel raggio specificato</span>
      <button mat-button class="reset-btn" (click)="resetSearch()">
        <mat-icon>restart_alt</mat-icon> Riprova
      </button>
    </ng-container>
  </div>

  <!-- Card edificio selezionato -->
  <div class="building-card" *ngIf="clickedBuilding">
    <div class="building-card-header">
      <mat-icon>business</mat-icon>
      <strong>{{ clickedBuilding.name }}</strong>
    </div>
    <div class="building-card-body">
      <span *ngIf="clickedBuilding.streetName || clickedBuilding.streetNumber">
        {{ clickedBuilding.streetName }} {{ clickedBuilding.streetNumber }}
      </span>
      <span *ngIf="clickedBuilding.city">, {{ clickedBuilding.city }}</span>
      <span *ngIf="clickedBuilding.zip"> ({{ clickedBuilding.zip }})</span>
      <span *ngIf="clickedBuilding.state">, {{ clickedBuilding.state }}</span>
      <div *ngIf="clickedBuilding.companyLocation || clickedBuilding.company" class="building-company">
        <mat-icon style="font-size:13px; vertical-align:middle;">domain</mat-icon>
        {{ clickedBuilding.companyLocation || clickedBuilding.company }}
      </div>
    </div>
  </div>

  <!-- Slider buffer: visibile solo prima della ricerca -->
  <div class="buffer-section" *ngIf="searchResults.length === 0 && !searchLoading">
    <mat-form-field appearance="outline" class="buffer-field">
      <mat-label>Buffer (metri)</mat-label>
      <input matInput type="number"
        [value]="bufferInput"
        (change)="onBufferInputChange(+$any($event.target).value)"
        min="50" max="50000" step="50" />
    </mat-form-field>
    <input type="range" class="buffer-slider"
      [min]="50" [max]="10000" [step]="50"
      [value]="bufferInput"
      (input)="onBufferSliderChange(+$any($event.target).value)" />
    <span class="buffer-label">{{ bufferMeters }} m</span>
  </div>

</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Annulla</button>

  <!-- Bottone Cerca: visibile prima della ricerca -->
  <button mat-raised-button color="primary"
    *ngIf="!hasSearched"
    [disabled]="!canSearch || searchLoading"
    (click)="search()">
    <mat-spinner *ngIf="searchLoading" diameter="18"
      style="display:inline-block; vertical-align:middle; margin-right:6px;"></mat-spinner>
    <mat-icon *ngIf="!searchLoading">search</mat-icon>
    Cerca
  </button>

  <!-- Bottone Seleziona: visibile dopo la ricerca, abilitato solo con marker cliccato -->
  <button mat-raised-button color="primary"
    *ngIf="hasSearched"
    [disabled]="!clickedBuilding"
    (click)="selectBuilding()">
    <mat-icon>check</mat-icon>
    Seleziona edificio
  </button>
</div>
